import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
"use strict";



var helpers = {
  json: function(context, replacer = null, space = 0) {
    const handleFunctions = typeof replacer === 'function' ? replacer : null;
    const handleWhitespace = typeof space === 'number' ? space : 0;
    return JSON.stringify(context, handleFunctions, handleWhitespace);
  }
};

class helpersJson {
  static register(Handlebars) {

    for (var helper in helpers) {
      if (helpers.hasOwnProperty(helper)) {
        Handlebars.registerHelper(helper, helpers[helper]);
      }
    }
  }
}

module.exports = helpersJson;
